import { render } from "./ResourceFormTextarea.vue?vue&type=template&id=884e2c40&ts=true"
import script from "./ResourceFormTextarea.vue?vue&type=script&lang=ts"
export * from "./ResourceFormTextarea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__